import api from 'apis/api';
import filterApiErr from 'apis/filterApiError';
import { LoginRespBody } from 'apis/RespBody';

import ERR_MSG from 'utils/errorMessage';

export const verifyEmailApi = async (email: string) => {
  try {
    await api.post('/api/v1/auth/verify-email', { email });
  } catch (_err: any) {
    let errMsg = '';

    const err = filterApiErr(_err);
    if (err) {
      const status = err.response.status;
      if (status === 400) {
        errMsg = '올바르지 않은 이메일입니다.';
      } else {
        const errMsgFromServer = err.response.data.message;
        if (errMsgFromServer) errMsg = errMsgFromServer;
        else errMsg = `${ERR_MSG.UNKNOWN} ${ERR_MSG.REPORT}`;
      }
    }

    return Promise.reject(errMsg);
  }
};

export const confirmCodeApi = async (email: string, code: string) => {
  try {
    const resp = await api.post('/api/v1/auth/confirm-code', { email, code });
    const data = resp.data as LoginRespBody;

    const accessTokenExpiresAt = data.access_token_expires_at;
    reserveLoginExtension(accessTokenExpiresAt * 1000);

    return Promise.resolve(data.user);
  } catch (_err: any) {
    let errMsg = '';

    const err = filterApiErr(_err);
    if (err) {
      const status = err.response.status;
      const hint = err.response.data.errors[0];

      if (status === 400) {
        errMsg = '이메일 또는 코드 입력 형식이 올바르지 않습니다.';
      } else if (status === 401 && hint === 'Invalid code') {
        errMsg = '코드가 유효하지 않습니다.';
      } else if (status === 401 && hint === 'Timed out') {
        errMsg = '코드가 만료되었습니다. 아래 링크를 눌러 재발송을 시도해보세요.';
      } else if (status === 410) {
        errMsg = '이미 확인이 된 코드입니다.';
      } else {
        const errMsgFromServer = err.response.data.message;
        if (errMsgFromServer) errMsg = errMsgFromServer;
        else errMsg = `${ERR_MSG.UNKNOWN} ${ERR_MSG.REPORT}`;
      }
    }

    return Promise.reject(errMsg);
  }
};

export const extendLogin = async () => {
  const resp = await api.post('/api/v1/auth/refresh');
  const data = resp.data as LoginRespBody;

  const accessTokenExpiresAt = data.access_token_expires_at;
  reserveLoginExtension(accessTokenExpiresAt * 1000);

  return Promise.resolve(data.user);
};

export const reserveLoginExtension = (accessTokenExpiresAtMS: number) => {
  const expirationTimeMS = accessTokenExpiresAtMS - Date.now();
  const extensionTimeMS = expirationTimeMS - 1 * 60 * 1000; // - ONE_MINUTE

  if (extensionTimeMS > 0) {
    // TODO: logging (something is wrong if extensionTimeMS is negative or not number)
    setTimeout(extendLogin, extensionTimeMS);
  }
};
